import React from "react";
import {Modal} from "react-bootstrap";
import PrismaZoom from "react-prismazoom";

function FileViewer(props) {
  const i = Math.random();
  // console.log(props);
  return (
    <Modal
      show={props.trigger}
      className="modal"
      onHide={() => props.hideTrigger(false)}
      key={i}
    >
      <Modal.Dialog>
        <Modal.Body>
          <div className="text-center">
            <PrismaZoom maxZoom="3">
              <img src={props.doc} alt="file" />
            </PrismaZoom>
          </div>
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  );
}
export default React.memo(FileViewer);
